import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect, useState, type ReactNode } from 'react';
import { useAuth } from './auth';

export function QueryProvider({ children }: { children: ReactNode }) {
  const [client] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
        },
      }),
  );

  // Wipe cached data whenever the authenticated user changes (sign-out or
  // account switch) so one account never mounts from another's fresh cache.
  useEffect(() => {
    return useAuth.subscribe((state, prev) => {
      if (state.token !== prev.token) client.clear();
    });
  }, [client]);

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
